// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"1b18b83e","205":"265fe282","274":"b46c3cdc","353":"fb8767b7","456":"232057d6","546":"75843d38","678":"33eb4dd5","744":"3130605f","885":"7589ca0a","963":"a7eb86d0"}[chunkId] + ".chunk.js";
};